const QUERY_KEYS = {
  // NOT used at the moment has used in the beginning to populate the widget notifications
  NOTIFICATIONS_LIST_MINIFIED: 'notifications-list-minified',
  // ------------------------------
  NOTIFICATIONS_LIST_FULL: 'notifications-list-full',
  NOTIFICATIONS_WIDGET: 'notifications-details',
  // ------------------------------Visits Calendar------------------------------
  VISITS_CALENDAR_MINIFIED_VISITS: 'visits-calendar-minified-visits',
  // ------------------------------Billing------------------------------
  BILLING_OVERVIEW_SUMMARY: 'billing-overview-summary',
  BILLING_OVERVIEW_RECENT_PAYMENTS: 'billing-overview-recent-payments',
  BILLING_BALANCES_SUMMARY: 'billing-balances-summary',
  BILLING_BALANCES_LIST: 'billing-balances-list',
  BILLING_RECENT_PAYMENTS_SIDEBAR: 'billing-recent-payments-sidebar',
  BILLING_CUSTOMER_PROFILE_PAYMENTS: 'customer-profile-payments',
  BILLING_PAYMENT_DETAILS: 'billing-payment-details',
  BILLING_PAYMENT_FORM_CLIENT: 'billing-payment-form-client',
  BILLING_PAYMENT_FORM_DOCTOR: 'billing-payment-form-doctor',
  BILLING_PAYMENT_FORM_CAREGIVER: 'billing-payment-form-caregiver',
  BILLING_PAYMENT_FORM_CLIENT_VISITS: 'billing-payment-form-client-visits',
  BILLING_PAYMENT_FORM_ENTITY_BALANCE: 'billing-payment-form-entity-balance',
  BILLING_CAREGIVER_CASH_LIST: 'billing-caregiver-cash-list',
  BILLING_CAREGIVER_CASH_TRANSACTIONS: 'billing-caregiver-cash-transactions',
  // ------------------------------Planning Sessions------------------------------
  PLANNING_SESSION_CURRENT: 'planning-session-current',
  PLANNING_SESSION_CHANGES: 'planning-session-changes',
} as const;

export const BILLING_QUERY_KEYS = {
  OVERVIEW_SUMMARY: QUERY_KEYS.BILLING_OVERVIEW_SUMMARY,
  OVERVIEW_RECENT_PAYMENTS: QUERY_KEYS.BILLING_OVERVIEW_RECENT_PAYMENTS,
  BALANCES_SUMMARY: QUERY_KEYS.BILLING_BALANCES_SUMMARY,
  BALANCES_LIST: QUERY_KEYS.BILLING_BALANCES_LIST,
  RECENT_PAYMENTS_SIDEBAR: QUERY_KEYS.BILLING_RECENT_PAYMENTS_SIDEBAR,
  CUSTOMER_PROFILE_PAYMENTS: QUERY_KEYS.BILLING_CUSTOMER_PROFILE_PAYMENTS,
  PAYMENT_DETAILS: QUERY_KEYS.BILLING_PAYMENT_DETAILS,
  PAYMENT_FORM_CLIENT: QUERY_KEYS.BILLING_PAYMENT_FORM_CLIENT,
  PAYMENT_FORM_DOCTOR: QUERY_KEYS.BILLING_PAYMENT_FORM_DOCTOR,
  PAYMENT_FORM_CAREGIVER: QUERY_KEYS.BILLING_PAYMENT_FORM_CAREGIVER,
  PAYMENT_FORM_CLIENT_VISITS: QUERY_KEYS.BILLING_PAYMENT_FORM_CLIENT_VISITS,
  PAYMENT_FORM_ENTITY_BALANCE: QUERY_KEYS.BILLING_PAYMENT_FORM_ENTITY_BALANCE,
  CAREGIVER_CASH_LIST: QUERY_KEYS.BILLING_CAREGIVER_CASH_LIST,
  CAREGIVER_CASH_TRANSACTIONS: QUERY_KEYS.BILLING_CAREGIVER_CASH_TRANSACTIONS,
} as const;

export default QUERY_KEYS;
